module.exports = __webpack_public_path__ + "img/pohled_z_venku_2.ad15aaf4.jpg";